import { Icon, Popup } from 'semantic-ui-react';

import { BasePopover } from '../../containers/Queue/CommentSummaryPopover/BasePopover';

/**
 * This component displays a popup with Patient's Latest Comment and Reviews Summary
 *
 * @param {object} props
 * @param {object} props.row
 * @param {string} props.row.patientName
 * @param {function} props.handleReviewsButton
 * @param {function} props.goToViewDo
 * @param {function} props.goToMessageFeed
 * @param {function} props.handleClose
 * @param {function} props.handleOpen
 */
const SummaryPopover = ({
  row,
  patientName,
  handleReviewsButton,
  goToViewDo,
  goToMessageFeed,
  handleClose,
  handleOpen,
}) => {
  return (
    <Popup
      id='CSPopover'
      trigger={
        <div className='patient-column'>
          <Icon name='content' className='comment-icon' />
          <p>{patientName}</p>
        </div>
      }
      content={
        <BasePopover
          patientInfo={row}
          patientDetails={handleReviewsButton || goToViewDo}
          goToMessageFeed={goToMessageFeed}
        />
      }
      on='hover'
      hoverable
      onClose={handleClose}
      onOpen={handleOpen}
      position='bottom left'
      style={{ maxWidth: 'min-content', zIndex: 2000 }}
    />
  );
};

export const popoverCellStyle = {
  minheight: '30px',
  height: '100%',
  width: '100%',
};

export default SummaryPopover;
